import { FC } from 'react';
import { Divider, Flex, HStack, Image } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import FlowerWithDome from '../../assets/FlowerWithDome@2x.png';
import locales from './locales';

interface NoResultsProps {
  onSkip: () => void;
  hasBeenSearchedBySIREN: boolean;
}

const NoResults: FC<NoResultsProps> = ({ hasBeenSearchedBySIREN, onSkip }) => {
  return (
    <Flex alignItems="center" flexDirection="column" justifyContent="center">
      <Image alt="empty-drawer" boxSize="120px" src={FlowerWithDome} />

      <Text fontWeight="weight-500" variant="primary">
        {locales.noResultCompany}
      </Text>

      {!hasBeenSearchedBySIREN ? (
        <Flex alignItems="center" flexDirection="column" margin="space-16">
          <Text textAlign="center" variant="secondary">
            {locales.noResultCheckForTyposMarkdown}
          </Text>

          <HStack alignItems="center" margin="space-32" width="100%">
            <Divider flexGrow={1} />

            <Text fontWeight="100" size="sm" variant="light">
              {locales.separatorOr.toLocaleUpperCase()}
            </Text>

            <Divider flexGrow={1} />
          </HStack>

          <Text variant="secondary">{locales.noResultNotAvailableCompany}</Text>
        </Flex>
      ) : null}

      <Button onClick={onSkip} variant="inline-primary">
        {locales.enterDetailsManually}
      </Button>
    </Flex>
  );
};

export default NoResults;
